module.exports = __webpack_public_path__ + "static/media/download.34cd9428.svg";